// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-item-help-text_root__lQTgd"};